var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#157EFB",
    id: "icon-29-information"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,22 L17,15.75 L17,15 L14,15 L14,16 L16,16 L16,22 L14,22 L14,23 L19,23 L19,22 L17,22 L17,22 L17,22 Z M16.5,29 C23.4035597,29 29,23.4035597 29,16.5 C29,9.59644029 23.4035597,4 16.5,4 C9.59644029,4 4,9.59644029 4,16.5 C4,23.4035597 9.59644029,29 16.5,29 L16.5,29 L16.5,29 Z M16.5,28 C22.8512749,28 28,22.8512749 28,16.5 C28,10.1487251 22.8512749,5 16.5,5 C10.1487251,5 5,10.1487251 5,16.5 C5,22.8512749 10.1487251,28 16.5,28 L16.5,28 L16.5,28 Z M16.5,13 C17.3284272,13 18,12.3284272 18,11.5 C18,10.6715728 17.3284272,10 16.5,10 C15.6715728,10 15,10.6715728 15,11.5 C15,12.3284272 15.6715728,13 16.5,13 L16.5,13 L16.5,13 Z",
    id: "information"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.f6df94c1012cbfc8e2b5b93452a45521.svg";
export { ForwardRef as ReactComponent };